import {CommonModule} from '@angular/common';
import {ModuleWithProviders, NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {MatBadgeModule} from '@angular/material/badge';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatDialogModule} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatSelectModule} from '@angular/material/select';
import {RouterModule, Routes} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';

import {SharedModule} from '@atmi/shared'; // TODO: Too much linked
import {FormModule} from '@sim/form';
import {UiModule} from '@ui/ui.module';

import {NgxSpinnerModule} from 'ngx-spinner';
import {MediaFiltersComponent} from './components/media-filters/media-filters.component';
import {MediaFormViewComponent} from './components/media-form-view/media-form-view.component';
import {MediaInputComponent} from './components/media-input/media-input.component';
import {MediaManagerDataComponent} from './components/media-manager-data/media-manager-data.component';
import {MediaManagerComponent} from './components/media-manager/media-manager.component';
import {MediaToUploadComponent} from './components/media-to-upload/media-to-upload.component';
import {MediaComponent} from './components/media/media.component';
import {ImagePickerDialogComponent} from './dialogs/image-picker-dialog/image-picker-dialog.component';
import {MediaModuleConfiguration} from './models/configuration';
import {MediaService} from './services/media.service';
import {UIMediaService} from './services/ui-media.service';
import {MediaConfigurationService} from './token';

export * from './components/media-manager-data/media-manager-data.component';
export * from './components/media-input/media-input.component';
export * from './components/media-manager/media-manager.component';
export * from './components/media-filters/media-filters.component';
export * from './components/media-to-upload/media-to-upload.component';
export * from './components/media/media.component';
export * from './models/configuration';
export * from './models/media';
export * from './services/media.service';
export * from './services/ui-media.service';
export * from './token';
export * from './utils';

const routes: Routes = [
  {
    children: [
      {
        component: MediaComponent,
        path: '',
      },
      {
        component: MediaManagerComponent,
        path: 'manager',
      },
      {
        component: MediaManagerComponent,
        path: 'manager/:id',
      },
    ],
    path: '',
  },
];

const COMPONENTS = [
  MediaFiltersComponent,
  MediaFormViewComponent,
];

const DIALOGS = [
  ImagePickerDialogComponent,
];

const MATERIAL = [
  MatBadgeModule,
  MatButtonModule,
  MatCardModule,
  MatDialogModule,
  MatFormFieldModule,
  MatIconModule,
  MatInputModule,
  MatPaginatorModule,
  MatSelectModule,
];

@NgModule({
  declarations: [
    ...COMPONENTS,
    ...DIALOGS,
    MediaComponent,
    MediaInputComponent,
    MediaManagerComponent,
    MediaManagerDataComponent,
    MediaToUploadComponent,
  ],
  exports: [
    ...COMPONENTS,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    NgxSpinnerModule,
    TranslateModule,
    SharedModule,
    FormModule,
    ReactiveFormsModule,
    UiModule,
    ...MATERIAL,
  ],
})
export class MediaModule {
  static forRoot(configuration: MediaModuleConfiguration): ModuleWithProviders<MediaModule> {
    return {
      ngModule: MediaModule,
      providers: [
        MediaService,
        UIMediaService,
        {useValue: configuration, provide: MediaConfigurationService},
      ],
    };
  }
}
